module.exports = __webpack_public_path__ + "img/lifeflow.39befd99.png";